"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseListedDateType = exports.getDateTypeLabel = exports.TIMEZONE = exports.ListedDateTypeKeys = exports.ListedDateType = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TIMEZONE = exports.TIMEZONE = process.env.TZ || 'Australia/Sydney';
var ListedDateTypeKeys = exports.ListedDateTypeKeys = ['TODAY', 'YESTERDAY', 'WITHIN_LAST_WEEK', 'SPECIFIC_DATE'];
var ListedDateType = exports.ListedDateType = {
  TODAY: {
    name: 'TODAY',
    offsetStart: 0,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Today%date',
    labelDateFormat: ', D MMMM'
  },
  YESTERDAY: {
    name: 'YESTERDAY',
    offsetStart: -1,
    offsetEnd: -1,
    offsetUnit: 'days',
    labelTemplate: 'Yesterday%date',
    labelDateFormat: ', D MMMM'
  },
  WITHIN_LAST_WEEK: {
    name: 'WITHIN_LAST_WEEK',
    offsetStart: -7,
    offsetEnd: 0,
    offsetUnit: 'days',
    labelTemplate: 'Within the last week'
  },
  SPECIFIC_DATE: {
    name: 'SPECIFIC_DATE',
    labelTemplate: '%date',
    labelDateFormat: 'dddd, D MMMM'
  }
};
var momentFormatter = (offset, offsetUnit, format, dateOverride) => {
  if (format) {
    var instance;
    if (offsetUnit) {
      instance = (0, _momentTimezone.default)().tz(TIMEZONE).add(offset, offsetUnit);
    } else if (dateOverride) {
      instance = _momentTimezone.default.tz(dateOverride, TIMEZONE);
    }
    return instance && instance.isValid() ? instance.format(format) : '';
  }
  return '';
};
var getDateTypeLabel = exports.getDateTypeLabel = function getDateTypeLabel(listedDateType, dateOverride) {
  var formatter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : momentFormatter;
  if (listedDateType && listedDateType.labelTemplate) {
    var label = listedDateType.labelTemplate;
    if (label.includes('%date') && listedDateType.labelDateFormat) {
      var formattedDate = formatter(listedDateType.offsetStart, listedDateType.offsetUnit, listedDateType.labelDateFormat, dateOverride) || '';
      label = label.replace('%date', formattedDate);
    }
    return label.trim();
  }
  return undefined;
};
var parseListedDateType = value => {
  if (!value) {
    return null;
  }
  var upperCaseValue = "".concat(value).toUpperCase();
  if (ListedDateTypeKeys.includes(upperCaseValue)) {
    return upperCaseValue;
  }
  return null;
};
exports.parseListedDateType = parseListedDateType;